import type { Instance } from 'mobx-state-tree'
import { PaginatedGamesDetailsResponseModelBase } from './PaginatedGamesDetailsResponseModel.base'

/* The TypeScript type of an instance of PaginatedGamesDetailsResponseModel */
export interface PaginatedGamesDetailsResponseModelType
  extends Instance<typeof PaginatedGamesDetailsResponseModel.Type> {}

/* A graphql query fragment builders for PaginatedGamesDetailsResponseModel */
export {
  PaginatedGamesDetailsResponseModelSelector,
  paginatedGamesDetailsResponseModelPrimitives,
  selectFromPaginatedGamesDetailsResponse
} from './PaginatedGamesDetailsResponseModel.base'

/**
 * PaginatedGamesDetailsResponseModel
 */
export const PaginatedGamesDetailsResponseModel = PaginatedGamesDetailsResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
